import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/overtime/styles.scss';export default {
  "overtime": "_overtime_a4l1z_1",
  "indicator": "_indicator_a4l1z_7"
};